import React from 'react'
import { Link } from 'gatsby'
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Card from 'components/Card/Card.js'
import CardBody from 'components/Card/CardBody.js'
import Button from 'components/CustomButtons/Button.js'
import Subject from '@material-ui/icons/Subject'

import Vivienda from "assets/img/sections/vivienda.png";
import Reformas from "assets/img/sections/salon.jpg";
import { CONSTRUCCION, REFORMAS } from 'constants/routes';

const CardLayout = ({ classes, href, title, desc, img }) => {
  return (
    <GridItem xs={12} md={6} lg={6}>
      <Card background style={{ backgroundImage: `url(${img})` }}>
        <Link to={href}>
          <CardBody background>
            <h3 className={classes.cardTitleWhite}>{title}</h3>
            <p className={classes.cardDescriptionWhite}>{desc}</p>
            <Button round color="danger">
              Entrar
            </Button>
          </CardBody>
        </Link>
      </Card>
    </GridItem>
  )
}

const LandingServices = ({ classes }) => {
  return (
    <div className={classes.wrapper}>
      <GridContainer>

        <CardLayout 
          classes={classes}
          img={Vivienda}
          href={CONSTRUCCION}
          title="Construcción de viviendas"
          desc='Nos hemos especializado en construcción de viviendas modulares, más económicas que la construcción tradicional y con calidades superiores. ¡Entra para más información!'
        />

        <CardLayout 
          classes={classes}
          img={Reformas}
          href={REFORMAS}
          title="Reformas"
          desc="¿Quieres reformar tu vivienda o local comercial? Somo especialistas en reformas en Barcelona y alrededores. Entra e infórmate."
        />

      </GridContainer>
    </div>
  )
}

export default LandingServices
